import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/products',
  component: Management,
  redirect: '/products/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/products/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listProducts
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/products/ListTable'),
          meta: {
            auth: Auth.listProducts,
            tabName: 'all'
          }
        },
        {
          path: 'pending',
          component: () => import('@/views/products/ListTable'),
          meta: {
            auth: Auth.listProducts,
            tabName: 'pending'
          }
        },
        {
          path: 'enabled',
          component: () => import('@/views/products/ListTable'),
          meta: {
            auth: Auth.listProducts,
            tabName: 'enabled'
          }
        },
        {
          path: 'disabled',
          component: () => import('@/views/products/ListTable'),
          meta: {
            auth: Auth.listProducts,
            tabName: 'disabled'
          }
        }
      ]
    },
    // 新增
    {
      path: 'new',
      component: () => import('@/views/products/New'),
      meta: {
        auth: Auth.createProduct
      }
    },
    // 编辑
    {
      path: ':id/edit',
      component: () => import('@/views/products/Edit'),
      meta: {
        auth: Auth.updateProduct
      }
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/products/DetailLayout'),
      meta: {
        auth: Auth.showProduct
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/products/details/Detail'),
          meta: {
            auth: Auth.showProduct,
            tabName: 'detail'
          }
        },
        // 订单信息
        {
          path: 'product_orders',
          component: () => import('@/views/products/details/ProductOrders'),
          meta: {
            auth: Auth.showProduct,
            tabName: 'product_orders'
          }
        }
      ]
    }
  ]
}
